export default {
      id: "icon--clock-small-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--clock-small-usage",
      toString: function () {
        return this.url;
      }
    }